import {IconNames} from "@variocube/cube-ui";
import {MessageKey} from "../../i18n";

export enum DeliveryMethod {
    phone = "phone",
    email = "email",
    display = "display"
}

interface MethodInfo {
    icon: IconNames;
    name: MessageKey;
    desc: MessageKey;
}

export function getMethodInfo(method: DeliveryMethod): MethodInfo {
    switch (method) {
        case DeliveryMethod.phone:
            return {
                icon: IconNames.textsms,
                name: "BookingCodeDeliveryMethodPhone",
                desc: "BookingCodeDeliveryMethodPhoneDesc"
            };
        case DeliveryMethod.email:
            return {
                icon: IconNames.email,
                name: "BookingCodeDeliveryMethodEmail",
                desc: "BookingCodeDeliveryMethodEmailDesc"
            };
        case DeliveryMethod.display:
            return {
                icon: IconNames.airplay,
                name: "BookingCodeDeliveryMethodDisplay",
                desc: "BookingCodeDeliveryMethodDisplayDesc"
            };
    }
}
